<mat-card class="basic-card" [ngClass]="css ? css : ''">
    <mat-card-content>
        <ng-content></ng-content>
    </mat-card-content>
</mat-card>